import { Backdrop, Box, ButtonGroup, Button as ButtonI, CircularProgress, Grid } from '@mui/material';
import InputForm from '../../../InputT';
import SearInputM from '../../../SearchModal';
import ParamsPicklist from '../../../../Types/ParamsPicklist';
import Table, { ColumnsType } from 'antd/es/table';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import EventIcon from '@mui/icons-material/Event';
import { useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import React, { useEffect, useState } from 'react';
import DataSelect from '../../../../Types/DataSelect';
import ExcelIcon from '../../../../Res/ExcelIcon.svg';
import { ExcelExport, ExcelExportColumn } from '@progress/kendo-react-excel-export';
import ReformatNumber from '../../../../Functions/Traitement/ReformatNumber';
import DataHistoCpt from '../../../../Types/DataHistoCpt';
import { Form, Input, Space } from 'antd';
import Data from '../../../../Data/Data.json';
import SelectOption from '../../../SelectOption';


let searchAgence: ParamsPicklist = { CodeAgence: "", Table: "AGENCE", Colonne1: "CODAGE", Colonne2: "LIBELLE", Colagence: "101", Choix: 22 }

 const dataOption: DataSelect[] = [
  { label: "0--Toutes les opérations", value: "0" },
  { label: "1--Encours de validation", value: "1" },
  { label: "2--Opérations rejetées", value: "2" },
  { label: "3--Opérations validées", value: "3" },
 // { label: "5--ALL", value: "5" }
]

const columnsHistorique: ColumnsType<DataHistoCpt> = [
  {
    title: 'Date Opération ',
    dataIndex: 'DATOPE',
    ellipsis: true,
    width: 100,
    align: 'left',

  },
  {
    title: 'Heure',
    dataIndex: 'TIME',
    ellipsis: true,
    width: 100,
    align: 'left',
  },
  {
    title: 'Numéro compte',
    dataIndex: 'NUMCPT',
    ellipsis: true,
    width: 150,
    align: 'left',
  },
  // {
  //   title: 'Date Valeur',
  //   dataIndex: 'DEDEVR',
  //   ellipsis: true,
  //   width: 100,
  //   align: 'left',
  // },
  {
    title: 'Ref Automatique',
    dataIndex: 'REPECE',
    ellipsis: true,
    width: 130,
    align: 'left',
  },
  {
    title: 'Ref Manuelle',
    dataIndex: 'NUMRAP',
    ellipsis: true,
    width: 120,
    align: 'left',
  },
  {
    title: 'Libelle',
    dataIndex: 'LIBELL',
    ellipsis: true,
    width: 200,
  },
  {
    title: 'Montant',
    dataIndex: 'MONTAN',
    ellipsis: true,
    width: 100,
  }
  ,
  {
    title: 'Sens opération',
    dataIndex: 'SENSEC',
    ellipsis: true,
    width: 100,
  },
  {
    title: 'Beneficiare',
    dataIndex: 'NBENEF',
    ellipsis: true,
    width: 120,
  },
  {
    title: 'Saisie par',
    dataIndex: 'UTISAI',
    ellipsis: true,
    width: 70,
  }
  ,
  {
    title: 'Validé par',
    dataIndex: 'UTIVAL',
    ellipsis: true,
    width: 70,
  }

];





const Tab1 = (props: { form?: any, data: any[] }) => {

  // USER SESSION
  const auth = useAuthUser();
  const user: Utilisateur = JSON.parse(JSON.stringify(auth()));
  // let searchCai: ParamsPicklist = { CodeAgence: user.codage, Table: "CAI", Colonne1: "NODECE", Colonne2: "LECEON", Colagence: "AEGECE", Choix: 22 }
  // let searchCodeOpe: ParamsPicklist = { CodeAgence: "", Table: "OPERAT", Colonne1: "CODOPE", Colonne2: "LIBELL", Colagence: "101", Choix: 22 }
  

  const [start, setstart] = useState(false);
  const [loading, setLoading] = useState(false);
  const [DataExcel, SetDataExcel] = useState<any[]>([]);

  // const _exporter = React.createRef<ExcelExport>();
  const _exporterBackOffice = React.createRef<ExcelExport>();

  // USER TOKEN
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  // const handleClick = (event: React.MouseEvent<HTMLElement>) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };


  const handleExport = () => {
    setLoading(false);
  }


  useEffect(() => {
    if (start == false) {
      props.form.setFieldValue("DateFin", user.datjour);
      props.form.setFieldValue("DateDebut", user.datjour);
      setstart(true)
    }
  }, []);


  const exportExcel = () => {
    setLoading(true);

    SetDataExcel([]);
    
          props.data.map((data: any, indice: any) => {
            DataExcel.push({
              key: indice,
              DATOPE: data.DATOPE,
              TIME: data.TIME,
              NUMCPT: data.NUMCPT,
              DEDEVR: data.DEDEVR,
              REPECE: data.REPECE,
              NUMRAP: data.NUMRAP,
              LIBELL: data.LIBELL,
              MONTAN: ReformatNumber(data.MONTAN ? data.MONTAN : ''),
              NBENEF: data.NBENEF,
              UTISAI: data.UTISAI,
              UTIVAL: data.UTIVAL,
               SENSEC: data.SENSEC
            })
          })
          if (!_exporterBackOffice.current) {
            return;
          }
          _exporterBackOffice.current.save();
      
    setLoading(true);
  };



  return (
    <div className='tabItem'>
      <Box  className='bordure1' width={"85%"} position={"absolute"}>
          
          <Box fontStyle="inherit" className='bordure1' >

              <SearInputM  defaultCode={user.codage} defaultLibelle={user.agence} disabled={true} width={2} Titre={"Recherche D'agence"} label={"Agence"} name={"Agence"} Parametre={searchAgence} form={props.form} />
              {/* <SelectOption Option={dataOption} width={10} widthl={0} label="Sens opération" Size={'middle'} name="TypeOpe" /> */}         
          </Box>
          <Box fontStyle="inherit" className='bordure1' style={{ display: 'flex' }} >
            <Grid container spacing={0}>
            <Grid item xs={6} sm={6} md={4} lg={4}>
              <InputForm icon={<EventIcon color='success' />} label={" Date Debut"} name={"DateDebut"} type='date' />
              </Grid>
              <Grid item xs={6} sm={6} md={4} lg={4}>
              <InputForm icon={<EventBusyIcon color='info' />} label={"Date Fin"} name={'DateFin'} type='date' />
              </Grid>
               <Grid item xs={6} sm={6} md={4} lg={4}>
              <ButtonGroup disableElevation color='success' variant="outlined" aria-label="Disabled elevation buttons">
                <ButtonI disabled={props.data.length >= 1 ? false : true} onClick={exportExcel}>
                  <img  src={ExcelIcon}></img> </ButtonI>
              </ButtonGroup>
              </Grid>
           </Grid>
          </Box>
                      
            <Box fontStyle="inherit" className='bordure1' >
              <Table  size='small' style={{ width: 'auto' }} columns={columnsHistorique} dataSource={props.data} scroll={{ y: 320, x: 1200 }}  />
            </Box>

          <Box display={"flex"} className='bordure1' fontStyle="inherit">
           
            <Space.Compact style={{ marginLeft: '5%' }} size="middle" >
              <Form.Item style={{ width: '70%' }} label="Total Débit / Nombre débit" name='TotalDebit'><Input disabled /></Form.Item>
              <Form.Item style={{ width: '14%' }} name='Nbrdebit'><Input disabled /></Form.Item>
            </Space.Compact>

             <Space.Compact style={{ marginLeft: '5%' }} size="middle" >
              <Form.Item style={{ width: '70%' }} label="Total Crédit / Nombre crédit" name='TotalCrebit'><Input disabled /></Form.Item>
              <Form.Item style={{ width: '14%' }} name='NbrCrebit'><Input disabled /></Form.Item>
            </Space.Compact>

         </Box>

       
      </Box>

      <ExcelExport  filterable data={DataExcel} fileName={"ListingComptabilise "+"_"+user.codage+"_"+user.coduti+"_"+Data.LocalVariable.appName+"_"+Date.now()+".xlsx"} ref={_exporterBackOffice} onExportComplete={handleExport}>
        <ExcelExportColumn field="DATOPE" title="Date Opération" locked={true} width={150} />
        <ExcelExportColumn field="TIME" title="Heure"  locked={true} width={70} />
        <ExcelExportColumn field="DEDEVR" title="Date De Valeur" width={100} />
        <ExcelExportColumn field="NUMCPT" title="NUMCPT" />
        <ExcelExportColumn field="REPECE" title="Reference" />
        <ExcelExportColumn field="NUMRAP" title="Ref Manuelle" />
        <ExcelExportColumn field="LIBELL" title="Libelle"  width={250} />
        <ExcelExportColumn field="MONTAN" title="MONTANT" />
        <ExcelExportColumn field="NBENEF" title="Beneficiare" />
      </ExcelExport>

      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading} >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>

  );

}

export default Tab1;